import React, { useState, useRef, MouseEvent } from 'react'
import Modal from "react-modal"
import styles from '../../styles/front/youtube/VideoModal.module.sass'

type Video = {
  thumbnail_image: string,
  video_url: string,
}

type VideoModalProps = {
  video: Video,
  default_alt: string,
}

Modal.setAppElement('.content-box');

const VideoModal = (props: VideoModalProps) => {
  const {
    video,
    default_alt,
  } = props

  const [isModalShow, setIsModalShow] = useState<boolean>(false)

  const openModal = (e: MouseEvent<HTMLInputElement>) => {
    e.preventDefault()
    setIsModalShow(true)
  }

  const closeModal = (e: MouseEvent<HTMLInputElement>) => {
    e.preventDefault()
    setIsModalShow(false)
  }

  const handleOverlayClick = () => {
    setIsModalShow(false);
  }

  return (
    <>
      <button type="button" className={styles.openModalButton} onClick={openModal}>
        <img
          alt={default_alt}
          src={video.thumbnail_image}
          loading='lazy'
          />
      </button>
      <Modal
        isOpen={isModalShow}
        onRequestClose={handleOverlayClick}
        bodyOpenClassName={styles.modalBackground}
        overlayClassName={styles.modalWrapper}
        className={styles.modal}
      >
        <div className={styles.modalClosed}>
          <button className={styles.closeButton} onClick={closeModal}>✕</button>
        </div>

        <iframe
          id="player"
          type="text/html"
          src={`${video.video_url}?autoplay=1`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </Modal>
    </>
  )
}

export default VideoModal
